import { TokenDto } from "./token-dto";

export enum TipoAutenticacao {
    Validado,
    Anonimo
}

export enum TipoArmazenamento {
    Sessao,
    Local
}

export class AutenticacaoDto {
    tipoAutenticacao: TipoAutenticacao = TipoAutenticacao.Anonimo;
    tipoArmazenamento: TipoArmazenamento = TipoArmazenamento.Local;

    token: TokenDto = new TokenDto();

    constructor(init?: Partial<AutenticacaoDto>) {
        Object.assign(this, init);
    }
}